var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#5F50F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16V20.001H11V26H10V29H11H14H16H19H21H24H26L29 29.001V29H30V26H29V20.001H30V16L20 10L10 16ZM14 26V20.001H16V26H14ZM19 26V20.001H21V26H19ZM26 26H24V20.001H26V26ZM22 16C22 17.104 21.104 18 20 18C18.896 18 18 17.104 18 16C18 14.896 18.896 14 20 14C21.104 14 22 14.896 22 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpends);
export default __webpack_public_path__ + "static/media/expends.930d3751bae5f8aa1fa09819a38ad6a6.svg";
export { ForwardRef as ReactComponent };